export default (clientHttp) => ({
  signOut() {
    return clientHttp.delete('v1/auth/sign_out')
  },

  /**
   *
   * @returns {Promise<{ data: import('@@/types/types').Auth['user']}}>}
   */
  validateToken() {
    return clientHttp.get('v1/auth/validate_token')
  },
})
